import React, { Component } from 'react';

import { Table, TableHeader, TableRow, TableCell, TableBody, Meter, Grid, Box, Stack, Text, Heading } from "grommet";
import { Helmet } from "react-helmet";
import LoginComponent from "../../components/Login";




export default class QueuePage extends Component {

  constructor() {
    super();
    this.setLogin = this.setLogin.bind(this);
    this.queryQueue = this.queryQueue.bind(this);
    this.count = this.count.bind(this);
    this.state = {
      refreshInterval: 5000
    };
    this.queues = [
      { name: "Preview", url: "https://queue.dart.masterdocs.com.au/stats" },
      { name: "Publish", url: "https://queue.dart.masterdocs.com.au/publish/stats" }
    ];
    this.appdetails = {
      clientId: "720f8c6b-406e-473c-8f48-103c54ccbbc1",
      authorityHost: "https://login.microsoftonline.com",
      tenantId: "c5f9cef3-6300-4cc2-90f6-be1b3f6e31d8"
    };
  }

  componentDidMount() {
    this.interval = window.setInterval(this.queryQueue, this.state.refreshInterval);
    this.queryQueue();
  }

  componentWillUnmount() {
    window.clearInterval(this.interval);
  }

  async queryQueue() {
    for (const { name, url } of this.queues) {
      const data = await fetch(url);
      const json = await data.json();
      this.setState({
        [name]: json
      });
    }
  }

  async setLogin() {

    const { InteractiveBrowserCredential } = await import(/* webpackChunkName: "@azure/identity" */ '@azure/identity');
    const { BlobServiceClient } = await import(/* webpackChunkName: "@azure/storage-blob" */ '@azure/storage-blob');

    // Enter your storage account name
    const defaultAzureCredential = new InteractiveBrowserCredential(this.appdetails);

    const blobServiceClient = new BlobServiceClient(
      `https://${this.account}.blob.core.windows.net`,
      defaultAzureCredential
    );
    return blobServiceClient;
  }

  static colorHashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let colour = '#';
    for (var i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
  }

  count(name, by) {
    return this.state[name]?.[by]?.map(i => i?.match(/\[.+\]$/)?.[0]?.slice(1,-1)).reduce((p, key) => ({
      ...p,
      [key]: p[key]+1 || 1
    }), {}) || {};
  }

  render() {
    return (<LoginComponent>{() => (<div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Queue Status - MD Dashboard</title>
      </Helmet>
      <Heading level={1}>Queue Status</Heading>
      {this.queues.map(({ name }) => <React.Fragment key={name}>
      <Heading key={`${name}-title`} level={2}>{name}</Heading>
      {this.state[name]?.FailedCount > this.state[name]?.CompletedCount && (<Box
        direction="row"
        border={{ color: 'status-critical', size: 'large' }}
        pad="medium"
        elevation="small"
        align="center"
        alignContent="center"
        margin={{bottom: "large"}}
      >
        <Text>{name} queue is constantly <strong>failing</strong>! Make sure the {name} queue is working correctly!</Text>
      </Box>)}
      <Grid
        rows={['auto', 'auto']}
        columns={['auto', 'auto', 'auto']}
        gap="small"
        areas={[
          { name: 'c1', start: [0, 0], end: [0, 0] },
          { name: 'c2', start: [1, 0], end: [1, 0] },
          { name: 'c3', start: [2, 0], end: [2, 0] },
          { name: 'a1', start: [0, 1], end: [0, 1] },
          { name: 'a2', start: [1, 1], end: [1, 1] },
          { name: 'a3', start: [2, 1], end: [2, 1] },
        ]}
      >
        <Table gridArea="c1" key={`${name}-table`} caption={`${name} queue activity`}>
          <TableHeader>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Metric
              </TableCell>
              <TableCell scope="col" border="bottom">
                Count
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Completed
              </TableCell>
              <TableCell scope="col" border="bottom">
                {this.state[name]?.CompletedCount}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Active
              </TableCell>
              <TableCell scope="col" border="bottom">
                {this.state[name]?.ActiveCount}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Waiting
              </TableCell>
              <TableCell scope="col" border="bottom">
                {this.state[name]?.WaitingCount}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Failed
              </TableCell>
              <TableCell scope="col" border="bottom">
                {this.state[name]?.FailedCount}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Box gridArea="c2" align="center" pad="large">
          <Heading level={3}>Completed requests</Heading>
          <Stack anchor="center">
            <Meter
              type="circle"
              background="light-2"
              values={Object.entries(this.count(name, "Completed"))?.map(([key, value]) => ({
                value,
                color: QueuePage.colorHashCode(key), // ensure same entity has always the same color accross diagrams
                label: key,
                onHover: over => this.setState({
                  [`${name}-Completed-Barchart`]: over ? { key, value } : { key: null, value: null }
                })
              }))}
              size="small"
              aria-label={`Completed ${name} requests by entity`}
              thickness="medium"
              max={this.state[name]?.Completed.length}
            />
            <Box align="center">
              <Box direction="row" align="center" pad={{ bottom: "xsmall" }}>
                <Text size="xxlarge" weight="bold">
                  {this.state[`${name}-Completed-Barchart`]?.value || this.state[name]?.Completed.length}
                </Text>
                <Text></Text>
              </Box>
              <Text>{this.state[`${name}-Completed-Barchart`]?.key || "Total"}</Text>
            </Box>
          </Stack>
        </Box>

        <Box gridArea="c3" align="center" pad="large">
          <Heading level={3}>Failed requests</Heading>
          <Stack anchor="center">
            <Meter
              type="circle"
              background="light-2"
              values={Object.entries(this.count(name, "Failed"))?.map(([key, value]) => ({
                value,
                color: QueuePage.colorHashCode(key), // ensure same entity has always the same color accross diagrams
                label: key,
                onHover: over => this.setState({
                  [`${name}-Failed-Barchart`]: over ? { key, value } : { key: null, value: null }
                })
              }))}
              size="small"
              aria-label={`Failed ${name} requests by entity`}
              thickness="medium"
              max={this.state[name]?.Failed.length}
            />
            <Box align="center">
              <Box direction="row" align="center" pad={{ bottom: "xsmall" }}>
                <Text size="xxlarge" weight="bold">
                  {this.state[`${name}-Failed-Barchart`]?.value || this.state[name]?.Failed.length}
                </Text>
                <Text></Text>
              </Box>
              <Text>{this.state[`${name}-Failed-Barchart`]?.key || "Total"}</Text>
            </Box>
          </Stack>
        </Box>
    </Grid>
    </React.Fragment>)}
    </div>)}</LoginComponent>);
  }
}
